import IDS from 'constants/IDvariables';

export const getIdNumberPrefixByIdType = ({ country, idType }) => {
    if (process.env.NODE_ENV === 'production') {
        switch (country?.code) {
            case 'VEN':
                switch (idType?.id) {
                    case IDS.VEN_CEDULA_IDENTIDAD:
                        return 'V';
                    case IDS.VEN_CEDULA_EXTRANJERIA:
                        return 'E';
                    default:
                        return '';
                }
            default:
                return '';
        }
    }

    switch (country?.code) {
        case 'VEN':
            switch (idType?.id) {
                case IDS.VEN_CEDULA_IDENTIDAD:
                    return 'V';
                case IDS.VEN_CEDULA_EXTRANJERIA:
                    return 'E';
                default:
                    return '';
            }
        default:
            return '';
    }
};

export const getIdNumber = ({ country, idType, idNumber, idNumberPrefix }) => {
    const numberPrefix = idNumberPrefix?.value || getIdNumberPrefixByIdType({ country, idType });

    return `${numberPrefix}${idNumber}`;
};
